import * as React from 'react';
import Box from '@mui/joy/Box';

export interface BookingStatusChipProps {
    status?: string | null;
    bookedIn?: string | null;
    size?: 'sm' | 'md';
}

type ResolvedChip = { label: string; bg: string; color: string };

function resolveLabelAndColor(
    status?: string | null,
    bookedIn?: string | null,
): ResolvedChip {
    if (status === 'Mark As Complete') return {label: 'Complete', bg: '#d1fae5', color: '#065f46'};
    if (status === 'Mark As Cancelled') return {label: 'Cancelled', bg: '#fee2e2', color: '#b91c1c'};
    if (status === 'Mark As Needs Rescheduling') return {label: 'Needs Rescheduling', bg: '#fef3c7', color: '#b45309'};

    if (!bookedIn) return {label: 'Booked', bg: '#f1f5f9', color: '#475569'};

    const when = new Date(bookedIn).getTime();
    if (Number.isNaN(when)) return {label: 'Booked', bg: '#f1f5f9', color: '#475569'};

    return when > Date.now()
        ? {label: 'Upcoming', bg: '#dbeafe', color: '#1e40af'}
        : {label: 'In Progress', bg: '#f1f5f9', color: '#475569'};
}

export default function BookingStatusChip({status, bookedIn, size = 'sm'}: BookingStatusChipProps) {
    const chip = resolveLabelAndColor(status, bookedIn);
    const isMd = size === 'md';
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                px: isMd ? 1 : 0.75,
                py: '2px',
                fontSize: isMd ? '11px' : '10px',
                fontWeight: 500,
                borderRadius: '9999px',
                flexShrink: 0,
                lineHeight: 1.4,
                bgcolor: chip.bg,
                color: chip.color,
            }}
            aria-label={`Booking status: ${chip.label}`}
        >
            {chip.label}
        </Box>
    );
}
